/**
 * useOrganizations - React Query hooks for organizations management
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { systemService } from '@/services/system.service';
import type {
  OrganizationFilters,
  CreateOrganizationDto,
} from '@/features/system/types/system.types';

/**
 * Hook para listar organizations com filtros
 */
export function useOrganizations(filters?: OrganizationFilters) {
  return useQuery({
    queryKey: ['system', 'organizations', filters],
    queryFn: () => systemService.listOrganizations(filters),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

/**
 * Hook para criar organization
 */
export function useCreateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateOrganizationDto) =>
      systemService.createOrganization(dto),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['system', 'organizations'],
      });
      void queryClient.invalidateQueries({ queryKey: ['system', 'overview'] });
    },
  });
}
